import { makeGraphQLQuery } from '../request.gql';

export const getTranslationLatestUpdateTime = async ({ token }) => {
    const { r, e } = await makeGraphQLQuery({
        query: `query handleGetTranslationLatestUpdateTime {
            translation_latest_update_time { timestamp }
        }`,
        token,
    });
    if (e) throw e;
    return r?.translation_latest_update_time;
};

export const getTranslationJson = async ({ token, client }) => {
    const { r, e } = await makeGraphQLQuery({
        query: `query handleGetTranslationJson($client: ID) {
            translation_json(client: $client) {
                timestamp
                languages
                translations
            }
        }`,
        variables: client == null || client === '' ? {} : { client },
        token,
    });
    if (e) throw e;
    return r?.translation_json;
};
